import './LabelInspectedBy.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LabelInspectedBy extends Component {
    render() {
        const { size } = this.props;
        return (
            <div className={`LabelInspectedBy _${size}`}>
                <div className={'Label'}>{'Inspected By:'}</div>
                <div className={'Signatures'}>
                    <div className={'signature left'}>{'x'}</div>
                    <div className={'signature right'}>{'x'}</div>
                </div>
            </div>
        );
    }
}

LabelInspectedBy.defaultProps = {
};

LabelInspectedBy.propTypes = {
    size: PropTypes.string.isRequired,
};

export default LabelInspectedBy;